import React from 'react';

const componentClass = 'trackList';

const ContentBroadcastTracks = ({ broadcastData, broadcastBlockIndex }) => {
    const targetBlockIndex = broadcastBlockIndex || broadcastData?.targetTrack?.blockIndex;

    const listOfTracks = (broadcastData?.broadcastInformationTracks || []).map((t,i) => {
        const { title, description, timeStart, timeStop } = t;
        const isActiveBlock = targetBlockIndex === i;
        return <li>
            <div className="d-none"></div>
            <div className={`trackList__trackInfo ${isActiveBlock && 'withPadding'}`}>
                <span>{ title }</span>
                <i>{ description }</i>
                <label>{timeStart} - {timeStop}</label>
            </div>
            { isActiveBlock && <span className="trackList__icon"><i className="fa fa-star" /></span> }
        </li>
    });

    return <ul className={componentClass}>{ broadcastData ? listOfTracks : 'Loading...'}</ul>;
};

export default ContentBroadcastTracks;
